import { css } from '@eti/styles';
import { date } from '@eti/utils';

interface FormattedSearchTripDateProps {
  dateFormat?: string;
  endDate?: string;
  startDate: string;
}

const styledDepartureDatesStyles = css`
  display: flex;
  justify-content: center;
`;

const styledSeparatorStyles = css`
  display: inline-block;
  padding: 0 0.35rem;
`;

const FormattedSearchTripDate = ({
  startDate,
  endDate,
  dateFormat = 'd MMM yyyy',
}: FormattedSearchTripDateProps) => (
  <h2 className={styledDepartureDatesStyles}>
    {endDate ? (
      <>
        <span>{date.format(startDate, dateFormat)}</span>
        <span className={styledSeparatorStyles}>–</span>
        <span>{date.format(endDate, dateFormat)}</span>
      </>
    ) : (
      <span>{date.format(startDate, dateFormat)}</span>
    )}
  </h2>
);

export default FormattedSearchTripDate;
